export default function PricingPlans() {
  const plans = [
    {
      name: 'ライトプラン',
      icon: '🌱',
      price: '5万円',
      period: '月額',
      description: '補助金について最低限は押さえておきたい企業向けのエントリープラン',
      features: [
        '最新補助金情報の随時配信',
        '年4回の補助金診断レポート',
        '申請サポート（成功報酬10%）',
        '法務サービス割引価格',
        'メール・チャット相談'
      ],
      recommended: false
    },
    {
      name: '経費削減プラン',
      icon: '💼',
      price: '10万円',
      period: '月額',
      description: '補助金を利用して固定費を確実に下げたい企業向けの実益特化プラン',
      features: [
        '毎月1回の診断レポート',
        '申請サポート年2回無料',
        '3件目以降は成功報酬8%',
        '法務サポート顧問価格',
        'LP制作1本7万円'
      ],
      recommended: false
    },
    {
      name: '補助金 × 集客支援プラン',
      icon: '📈',
      price: '20万円',
      period: '月額',
      description: '補助金を自社の営業武器として使いたい企業に最適',
      features: [
        '毎月2回の補助金診断',
        '自社申請サポート年4回無料',
        '顧客向け補助金・助成金活用マーケティング設計',
        '顧客向け申請代行成功報酬3%のみ',
        '法務サポート顧問価格',
        'LP制作3万円'
      ],
      recommended: true
    },
    {
      name: '完全フル支援プラン',
      icon: '👑',
      price: '40万円',
      period: '月額',
      description: '外部補助金部＋法務部＋LP制作部を全部まとめて外注したい企業向け',
      features: [
        '補助金診断月4回',
        '顧客向け診断月3回',
        '自社申請サポート無料',
        '顧客向け補助金・助成金活用マーケティング設計',
        '顧客用申請サポート月5回無料、6回目以降1%のみ',
        '法務サポート月2件無料',
        'LP制作2万円'
      ],
      recommended: false
    }
  ];

  return (
    <section id="pricing" className="py-24 bg-gradient-to-br from-gray-50 to-blue-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h3 className="text-4xl font-bold text-gray-900 mb-4" style={{ fontFamily: '"Noto Sans JP", sans-serif' }}>
            <span className="text-blue-900">4つの料金プラン</span>から選べる
          </h3>
          <p className="text-lg text-gray-600">企業規模や活用目的に合わせて最適なプランをご提案</p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {plans.map((plan, index) => (
            <div 
              key={index}
              className="relative bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all group"
            >
              {plan.recommended && (
                <div className="absolute -top-4 left-1/2 transform -translate-x-1/2 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <span className="bg-gradient-to-r from-orange-500 to-orange-600 text-white px-6 py-2 rounded-full text-sm font-bold shadow-lg whitespace-nowrap">
                    おすすめ
                  </span>
                </div>
              )}

              <div className="text-center mb-6">
                <div className="text-5xl mb-3">{plan.icon}</div>
                <h4 className="text-2xl font-bold text-gray-900 mb-2" style={{ fontFamily: '"Noto Sans JP", sans-serif' }}>
                  {plan.name}
                </h4>
                <div className="flex items-baseline justify-center gap-2 mb-3">
                  <span className="text-4xl font-bold text-blue-900">{plan.price}</span>
                  <span className="text-gray-600">/ {plan.period}</span>
                </div>
                <p className="text-sm text-gray-600 leading-relaxed min-h-[60px]">
                  {plan.description}
                </p>
              </div>

              <div className="space-y-3 mb-8">
                {plan.features.map((feature, idx) => (
                  <div key={idx} className="flex items-start gap-3">
                    <i className="ri-check-line text-green-500 text-xl flex-shrink-0 mt-0.5"></i>
                    <span className="text-gray-700 text-sm leading-relaxed">{feature}</span>
                  </div>
                ))}
              </div>

              <a 
                href="mailto:info@alicelink.com"
                className="block w-full py-3 rounded-lg font-bold transition-all whitespace-nowrap cursor-pointer text-center bg-blue-900 text-white hover:bg-blue-800"
              >
                このプランで相談する
              </a>
            </div>
          ))}
        </div>

        <div className="mt-12 text-center space-y-3">
          <p className="text-gray-600">
            <i className="ri-information-line text-blue-900 mr-2"></i>
            すべてのプランで初回無料相談を実施しています
          </p>
          <p className="text-sm text-gray-500">
            ※ご契約期間は12か月間となります
          </p>
        </div>
      </div>
    </section>
  );
}